import React, { useState } from "react";
import Listening from "./Listening";
import quizData1 from "../data/quiz_story1.json";
import quizData2 from "../data/quiz_story2.json";
import quizData3 from "../data/quiz_story3.json";
import quizData4 from "../data/quiz_story4.json";
import quizData5 from "../data/quiz_story5.json";
import quizData6 from "../data/quiz_story6.json";
import quizData7 from "../data/quiz_story7.json";

const stories = [
  {
    id: "story1",
    labelKey: "story1Title",
    quizData: quizData1,
    getAudioFile: (lang) => {
      switch (lang) {
        case "de": return require("../data/audio/DE_Story1_11labs.mp3");
        case "cs": return require("../data/audio/CS_Story1_11labs.mp3");
        case "bg": return require("../data/audio/BG_Story1_11labs.mp3");
        default: return null;
      }
    }
  },
  {
    id: "story2",
    labelKey: "story2Title",
    quizData: quizData2,
    getAudioFile: (lang) => {
      switch (lang) {
        case "de": return require("../data/audio/DE_Story2_11labs.mp3");
        case "cs": return require("../data/audio/CS_Story2_11labs.mp3");
        case "bg": return require("../data/audio/BG_Story2_11labs.mp3");
        default: return null;
      }
    }
  },
  {
    id: "story3",
    labelKey: "story3Title",
    quizData: quizData3,
    getAudioFile: (lang) => {
      switch (lang) {
        case "de": return require("../data/audio/DE_Story3_11labs.mp3");
        case "cs": return require("../data/audio/CS_Story3_11labs.mp3");
        case "bg": return require("../data/audio/BG_Story3_11labs.mp3");
        default: return null;
      }
    }
  },
  {
    id: "story4",
    labelKey: "story4Title",
    quizData: quizData4,
    getAudioFile: (lang) => {
      switch (lang) {
        case "de": return require("../data/audio/DE_Story4_11labs.mp3");
        case "cs": return require("../data/audio/CS_Story4_11labs.mp3");
        case "bg": return require("../data/audio/BG_Story4_11labs.mp3");
        default: return null;
      }
    }
  },
  {
    id: "story5",
    labelKey: "story5Title",
    quizData: quizData5,
    getAudioFile: (lang) => {
      switch (lang) {
        case "de": return require("../data/audio/DE_Story5_11labs.mp3");
        case "cs": return require("../data/audio/CS_Story5_11labs.mp3");
        case "bg": return require("../data/audio/BG_Story5_11labs.mp3");
        default: return null;
      }
    }
  },
  {
    id: "story6",
    labelKey: "story6Title",
    quizData: quizData6,
    getAudioFile: (lang) => {
      switch (lang) {
        case "de": return require("../data/audio/DE_Story6_11labs.mp3");
        case "cs": return require("../data/audio/CS_Story6_11labs.mp3");
        case "bg": return require("../data/audio/BG_Story6_11labs.mp3");
        default: return null;
      }
    }
  },
  {
    id: "story7",
    labelKey: "story7Title",
    quizData: quizData7,
    getAudioFile: (lang) => {
      switch (lang) {
        case "de": return require("../data/audio/DE_Story7_11labs.mp3");
        case "cs": return require("../data/audio/CS_Story7_11labs.mp3");
        case "bg": return require("../data/audio/BG_Story7_11labs.mp3");
        default: return null;
      }
    }
  }
];

const ListeningStories = ({ language, labels }) => {
  const [selectedStory, setSelectedStory] = useState(null);

  if (!selectedStory) {
    return (
      <div style={{ maxWidth: 600, margin: "0 auto", padding: 24 }}>
        <h2>{labels.listening || "Listening"}</h2>
        <div style={{ margin: "32px 0" }}>
          {stories.map(story => (
            <button
              key={story.id}
              onClick={() => setSelectedStory(story)}
              className="green-button"
              style={{
                display: 'block',
                width: '100%',
                marginBottom: 20,
                padding: 20,
                fontSize: '1.2em',
                borderRadius: 12,
                fontWeight: 600
              }}
            >
              {labels[story.labelKey]}
            </button>
          ))}
        </div>
      </div>
    );
  }

  return (
    <div>
      <button
        onClick={() => setSelectedStory(null)}
        className="green-button"
        style={{ marginBottom: 16 }}
      >
        ← {labels.backToStories}
      </button>
      <Listening
        language={language}
        labels={labels}
        quizData={selectedStory.quizData}
        audioFile={selectedStory.getAudioFile(language)}
      />
    </div>
  );
};

export default ListeningStories; 